export const IconConst = {
  Cart: {
    d:
      'm 22.819083,5.2086444 h -17.55 l -0.75,-3.75 h -3.6 v 1.5 h 2.4 l 3,14.9999996 h 14.1 v -1.5 h -12.9 l -0.6,-3 h 14.1 z m -3,6.7499996 h -13.2 l -1.05,-5.2499996 h 15.375 z m -11.4,10.5 c -0.8284271,0 -1.5,-0.671573 -1.5,-1.5 0,-0.828427 0.6715729,-1.5 1.5,-1.5 0.8284271,0 1.5,0.671573 1.5,1.5 0,0.828427 -0.6715729,1.5 -1.5,1.5 z m 10.5,0 c -0.828427,0 -1.5,-0.671573 -1.5,-1.5 0,-0.828427 0.671573,-1.5 1.5,-1.5 0.828427,0 1.5,0.671573 1.5,1.5 0,0.828427 -0.671573,1.5 -1.5,1.5 z',
  },
}
